import React, { useState } from "react";
import {
  Box,
  Button,
  MenuItem,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { StyledMenu, StyledTableActionButton } from "@/components/styled";
import { capitalizeFirstLetter } from "@/utils/capitalizeFirstLetter.ts";
import SvgSimpleCheckMark from "@/assets/icons/SVGSimpleCheckMark.tsx";
import SVGFilter from "@/assets/icons/SVGFilter.tsx";

type Props = {
  selectedValue: string | undefined;
  setSelectedValue: (value: string | undefined) => void;
};

const BATTERY_OPERATIONALIZED_ITEMS = [
  { value: "1", label: "Operationalized Set" },
  { value: "0", label: "Not Set" },
];

const BatteryOperationalizedSelect = ({
  selectedValue,
  setSelectedValue,
}: Props) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const theme = useTheme();
  const downSm = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickItem = (value: string) => {
    const newSelectedItem = selectedValue === value ? undefined : value;
    setSelectedValue(newSelectedItem);
    handleClose();
  };

  const isSelected = (value: string) => selectedValue === value;

  const getDisplayText = () => {
    if (!selectedValue) return "Battery Operationalized";
    const item = BATTERY_OPERATIONALIZED_ITEMS.find(
      (item) => item.value === selectedValue
    );
    return item ? item.label : "Battery Operationalized";
  };

  return (
    <>
      <StyledTableActionButton
        onClick={handleClick}
        variant={selectedValue ? "outlined" : "outlinedGray"}
      >
        <Box sx={{ display: "flex", gap: "8px", alignItems: "center" }}>
          <SVGFilter />
          {!downSm && (
            <Typography
              variant={"subtitleRegular"}
              sx={{
                color: "textLightGray2",
                whiteSpace: "nowrap",
              }}
            >
              {getDisplayText()}
            </Typography>
          )}
        </Box>
      </StyledTableActionButton>
      <StyledMenu
        id="battery-operationalized-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "battery-operationalized-button",
        }}
        sx={{ "& .MuiPaper-root": { minWidth: "200px" } }}
      >
        {BATTERY_OPERATIONALIZED_ITEMS.map((el) => {
          return (
            <MenuItem
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
              key={el.value}
              onClick={() => handleClickItem(el.value)}
            >
              <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
                <Typography
                  sx={{ fontSize: "16px", fontWeight: 600, color: "#4E4B48" }}
                >
                  {capitalizeFirstLetter(el.label ?? "")}
                </Typography>
              </Box>
              {isSelected(el.value) && <SvgSimpleCheckMark color={"#0076CE"} />}
            </MenuItem>
          );
        })}
      </StyledMenu>
    </>
  );
};

export default BatteryOperationalizedSelect;
